__turbopack_context__.v({
  "actionButton": "startActions-module-scss-module__eXpd1a__actionButton",
  "bookDemoButton": "startActions-module-scss-module__eXpd1a__bookDemoButton",
  "buttonsDivider": "startActions-module-scss-module__eXpd1a__buttonsDivider",
  "getStartedButton": "startActions-module-scss-module__eXpd1a__getStartedButton",
});
